export const SET_CURRENT_PARTNER = 'SET_CURRENT_PARTNER';

export function setCurrentPartner(partner) {
  return {
    type: SET_CURRENT_PARTNER,
    meta: { partner }
  };
}
